var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.teatro.sga)?_c('PortalAbonadosSga'):_c('PortalAbonadosAvet')
}
var staticRenderFns = []

export { render, staticRenderFns }